import { isString } from 'lodash';
import { DesignObjectModel } from '../../model/design-object.model';

export const getDesignDraftId = (designObject?: DesignObjectModel | string) => {
  let uniqueId = 'new-designObject';
  if (designObject) {
    if (isString(designObject)) {
      uniqueId = designObject;
    } else {
      uniqueId = designObject.uniqueId;
    }
  }
  return `designDraft-${uniqueId}`;
};
